<template>
  <div class="audio">
    <div class="box">
      <template v-for="(item,key) in upload_list">
        <el-tooltip placement="top" :key="key" :content="item.filename">
          <div class="item">
            <div class="div" @click="upload_choose(key)">
              <img src="../../assets/audio.png" class="img" v-if="item.type=='mp3'">
              <div v-else>
                <video :src="item.url"></video>
                <img src="../../assets/video.png" class="img">
              </div>
            </div>
            <div class="text">{{(item.size/1024).toFixed(2)+ 'KB'}}</div>
            <el-popconfirm title="确认删除？" @confirm="del(item.id,item.newname)">
              <div class="iconfont icon-close-circle" slot="reference"></div>
            </el-popconfirm>
          </div>
        </el-tooltip>
      </template>
      <div style="width: 100%;height: 60px;"></div>
    </div>
    <div class="bottom">
      <div class="flex">
        <div v-if="choose" @click="unchoose">
          <el-tooltip placement="top" :content="choose.filename">

            <img src="../../assets/audio.png" class="img"
                 style="position: absolute;width: 30px;height: 30px;top: 50%;left: 50%;transform: translate(-50%,-50%);"
                 v-if="choose.type=='mp3'">
            <video :src="choose.url" class="video" v-else></video>
          </el-tooltip>

        </div>
      </div>
      <el-tag type="danger" class="mr-10">已使用容量：{{size}}M</el-tag>
      <el-button type="primary" size="small" class="mr-10" @click="confirm">确认</el-button>
      <el-upload class="upload-demo" :show-file-list="false"
                 :http-request="upload" :before-upload="upload_check"
                 accept="audio/*,video/*">
        <el-button type="success" size="small">上传</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  name: "upload-list",
  props:{},
  data(){
    return{
      upload_list:[],
      choose:'',
      size:'',
      upload_type:'',
    }
  },
  mounted() {
    this.get_upload_list(this.user.uid);
  },
  methods:{
    get_upload_list:async function (uid){
      let rs = await this.$_api.company('upload_list', {uid : uid});
      if (rs.errcode == 0){
        this.upload_list = rs.data;
        this.size = rs.size;
      }
    },
    upload_check:function (e){
      let that = this;
      console.log(e);
      let size = e.size / 1024 /1024;
      if (size > 10){
        that.$_showToastNone('最大只能上传10M');
        return false;
      }
    },
    upload:async function (e){
      console.log(e);
      try {
        console.log(e.file);
        if (e.file){
          this.$_showLoading();
          let res = await this.$_api.upload(e.file,'file','',this.user.uid);
          this.$_hideLoading();
          this.$_showToast(res.errmsg,res.style);
          this.get_upload_list(this.user.uid);
        }
      }catch (e) {
        console.log(e);
        return false;
      }
    },
    confirm:function (){
      if(!this.choose){
        this.$_showToastWarning('请选择音视频');
        return;
      }
      this.$emit('submit', this.choose);
    },
    upload_choose:function (index){
      let that = this;
      that.choose = '';
      setTimeout(function (){
        that.choose = that.upload_list[index];
      },100)
    },
    unchoose:function (){
      this.choose = '';
    },
    del:async function (id,name){
      this.$_showLoading();
      let res = await this.$_api.company('upload_del',{id:id,name:name,table:'upload_media'});
      this.$_hideLoading();
      this.$_showToast(res.errmsg,res.style);
      if(res.errcode == 0){
        this.get_upload_list(this.user.uid);
      }
    }
  }
}
</script>

<style scoped>

.flex{
  flex:1
}
.audio{
  width: 100%;
  height: 100%;
  position: relative;
}
.audio .box{
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  overflow-y: auto;
}
.audio .item {
  width:100px;
  height: 120px;
  margin: 0 22px 20px 0;
  cursor: pointer;
  position: relative;
}
.icon-close-circle{
  position: absolute;
  color: #dd524d;
  font-size: 20px;
  right: -4px;
  top: -2px;
}
.audio .div{
  width:100px;
  height: 100px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}
.audio .choose{
  border: 1px solid #dd524d;
}
.audio .item img,video{
  width:100px;
  height: 100px;
}
.audio .item .img{
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.audio .item .text{
  margin-top: 3px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
.audio .bottom{
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
}
.audio .bottom .flex div{
  width:50px;
  height: 50px;
  border: 1px solid #dd524d;
  border-radius: 5px;
  position: relative;
}
.audio .bottom .img, .video{
  width:50px;
  height: 50px;
}

</style>